module.exports = __webpack_public_path__ + "static/GMF-89d52b0c3940a64babc6c8ed95d4728f.pdf";